<template>
  <sfs-form-modal
    :id="modalId"
    title="Edit Service"
    size="lg"
    @on-hide="resetFormData"
  >
    <services-form
      v-bind="value"
      @on-submit="updateService"
      @on-save="onSave"
      @on-cancel="closeModal"
      :key="formKey"
    />
  </sfs-form-modal>
</template>

<script>
import ServicesForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'ServicesEditModal',
  mixins: [formModalMixin],
  components: {
    ServicesForm,
  },
  props: {
    value: Object,
  },
  data() {
    return {
      modalId: 'service-edit-modal',
    };
  },
  methods: {
    updateService(data, handleUpdate) {
      handleUpdate(this.$servicesAPI.update(this.$route.params.id, data));
    },
    onSave(service) {
      this.closeModal();
      this.$emit('input', service);
    },
  },
};
</script>
